<div class="borderColor bgHelper rounded-xl px-4 py-4">
  <h3 class="mb-4 block text-center text-base font-semibold">
    {{ isArabic() ? "ملخص الطلب" : "Order Summary" }}
  </h3>

  <div class="flex flex-col gap-4">
    <div class="flex items-center justify-between">
      <label>{{ isArabic() ? "رقم الطلب" : "Order Id" }}</label>
      <p>#{{ orderData().id }}</p>
    </div>

    <div class="flex items-center justify-between">
      <label i18n="@@totalQty">Total Quantity</label>
      <p>
        {{ totalQuantity() }}
        <span>{{ isArabic() ? "صنف" : "Items" }}</span>
      </p>
    </div>

    <div class="flex items-center justify-between">
      <label i18n="@@totalPharmacyPrice">Total Pharmacy Price</label>
      <p>
        {{ totalPharmacyPrice()?.toFixed(2) }}
        <span i18n="@@EGP">EGP</span>
      </p>
    </div>

    <div class="flex items-center justify-between">
      <label i18n="@@totalPeoplePrice">Total People Price</label>
      <p>
        {{ totalPeoplePrice()?.toFixed(2) }}
        <span i18n="@@EGP">EGP</span>
      </p>
    </div>
  </div>

  <div class="borderColor my-4"></div>

  <div class="mb-6 flex items-center justify-between">
    <label for="" i18n="@@total">Total</label>
    <p class="text-lg font-bold">
      {{ total()?.toFixed(2) }}
      <span i18n="@@EGP">EGP</span>
    </p>
  </div>

  <div class="flex w-full items-start gap-3 rounded-lg bg-gray-100 p-4">
    <div class="textPrimary shrink-0 rounded-lg bg-white p-2 shadow-sm">
      <app-truck-icon />
    </div>

    <div class="flex w-full flex-col gap-3">
      <h3
        [class.text-right]="isArabic()"
        [class.text-left]="!isArabic()"
        class="block text-base font-bold text-gray-800"
        i18n="@@deliveryInformation">
        {{ isArabic() ? "معلومات التوصيل" : "Delivery Information" }}
      </h3>

      <div class="flex flex-col gap-3 border-t border-gray-300 pt-3 text-sm">
        <div class="flex flex-col gap-1">
          <p class="font-bold text-gray-700">
            @if (deliveryMan()) {
              {{ isArabic() ? "تم التوصيل:" : "Delivered:" }}
            } @else {
              {{ isArabic() ? "التوصيل المتوقع:" : "Expected Delivery Time:" }}
            }
          </p>

          <p class="leading-relaxed font-semibold text-gray-900">
            {{ formatExpectedDelivery() }}
          </p>
        </div>

        <div class="border-t border-gray-200 pt-3">
          <p class="font-semibold text-gray-800">
            {{ placedOn() }}
          </p>
        </div>

        @if (deliveryMan()) {
          <div class="flex items-center justify-between border-t border-gray-200 pt-3">
            <p class="font-bold text-gray-700" i18n="@@deliveryMan">Delivery Man</p>

            <p class="font-semibold text-gray-800">
              {{ deliveryMan() }}
            </p>
          </div>
        }
      </div>
    </div>
  </div>
</div>
